
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import { ItemModel } from '~/types/ItemModel'
import { Artist } from '~/types/Artist'

@Component
export default class extends Vue {
  @Prop() itemModel!: ItemModel
  @Prop() itemType!: 'small' | 'medium' | 'large'
  @Prop() rateRange!: number
  @Prop() isArtist!: boolean
  @Prop({ default: 0 }) isMerchSale!: number

  alreadyRate: boolean = false

  buyPainting (painting) {
    const paint = { id: painting.id, name: painting.artist['name_' + this.$i18n.locale] }
    this.$eventBus.$emit('painting', paint)
  }

  vote () {
    this.alreadyRate = true

    const formData = new FormData()
    formData.append('vote', '1')
    return this.$axios.post(process.env.API_ENDPOINT + `/api/v3/sandbox-artists/${this.itemModel.item.id}/vote`, formData).then(() => {
      this.$emit('rate')
      const sandboxRating: number = parseInt((this.itemModel.item as Artist).sandbox_rating || '0');
      (this.itemModel.item as Artist).sandbox_rating = (sandboxRating + 1).toString()
    }).catch(() => {})
  }
}
